import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/Strength"
import { invokeSetAddStrengthAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class StrengthForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            userFormData: {}
        }

       this.setUserFormData = this.setUserFormData.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getStrengthAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var deadlift         = results.data[0].deadlift;
                var back_squat       = results.data[0].back_squat
                var front_squat      = results.data[0].front_squat
                var hex_bar_deadlift = results.data[0].hex_bar_deadlift
                var bench_press      = results.data[0].bench_press;
                var bent_over_row    = results.data[0].bent_over_row;
                var clean            = results.data[0].clean;
                var overhead_squat   = results.data[0].overhead_squat;
                var snatch           = results.data[0].snatch;
                var jerk             = results.data[0].jerk;
                var pull_up          = results.data[0].pull_up;

                // deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press,
                // bent_over_row, clean, overhead_squat, snatch, jerk, pull_up

                this.setState({
                    userFormData: {
                        deadlift:         deadlift,
                        back_squat:       back_squat,
                        front_squat:      front_squat,
                        hex_bar_deadlift: hex_bar_deadlift,
                        bench_press:      bench_press,
                        bent_over_row:    bent_over_row,
                        clean:            clean,
                        overhead_squat:   overhead_squat,
                        snatch:           snatch,
                        jerk:             jerk,
                        pull_up:          pull_up
                    }
                });
            }
        } else {
            this.setUserFormData("", "", "", "", "", "", "", "", "", "", "");
        }
    }

    setUserFormData(deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press, bent_over_row, clean, overhead_squat, snatch, jerk, pull_up) {
        this.setState({
            userFormData: {
                deadlift:         deadlift, // must have an int value; can't be ""
                back_squat:       back_squat,
                front_squat:      front_squat,
                hex_bar_deadlift: hex_bar_deadlift,
                bench_press:      bench_press,
                bent_over_row:    bent_over_row,
                clean:            clean,
                overhead_squat:   overhead_squat,
                snatch:           snatch,
                jerk:             jerk,
                pull_up:          pull_up
            }
        });
    }

    isObject(obj) {
        return obj != null && obj.constructor.name === "Object"
    }

    onSubmit = async (formData) => {
        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 8; // Strength is #8 in dropdown

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var obj = this.getObjectData(formData);

        var deadlift         = obj.deadlift;
        var back_squat       = obj.back_squat
        var front_squat      = obj.front_squat
        var hex_bar_deadlift = obj.hex_bar_deadlift
        var bench_press      = obj.bench_press;
        var bent_over_row    = obj.bent_over_row;
        var clean            = obj.clean;
        var overhead_squat   = obj.overhead_squat;
        var snatch           = obj.snatch;
        var jerk             = obj.jerk;
        var pull_up          = obj.pull_up;

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddStrengthAssessment(action, assessment_id, client_id, deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press, bent_over_row, clean, overhead_squat, snatch, jerk, pull_up)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    getObjectData = (formData) => {

        var deadlift;
        var back_squat;
        var front_squat;
        var hex_bar_deadlift;
        var bench_press;
        var bent_over_row;
        var clean;
        var overhead_squat;
        var snatch;
        var jerk;
        var pull_up;

        for(var key in formData) {
            var formData2 = formData[key];
            for(var key2 in formData2) {
                var data = formData2[key2];

                if(key2 === "deadlift" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    deadlift = data;
                } else if(key2 === "back_squat" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    back_squat = data;
                } else if(key2 === "front_squat" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    front_squat = data;
                } else if(key2 === "hex_bar_deadlift" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    hex_bar_deadlift = data;
                } else if(key2 === "bench_press" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    bench_press = data;
                } else if(key2 === "bent_over_row" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    bent_over_row = data;
                } else if(key2 === "clean" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    clean = data;
                } else if(key2 === "overhead_squat" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    overhead_squat = data;
                } else if(key2 === "snatch" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    snatch = data;
                } else if(key2 === "jerk" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    jerk = data;
                } else if(key2 === "pull_up" && this.isObject(data) == false) {
                    console.log("> key2: " + key2);
                    console.log("> formData2: " + data);
                    pull_up = data;
                }
            }
        }

        var obj = {};
        obj.deadlift         = deadlift
        obj.back_squat       = back_squat;
        obj.front_squat      = front_squat;
        obj.hex_bar_deadlift = hex_bar_deadlift
        obj.bench_press      = bench_press;
        obj.bent_over_row    = bent_over_row;
        obj.clean            = clean;
        obj.overhead_squat   = overhead_squat;
        obj.snatch           = snatch;
        obj.jerk             = jerk;
        obj.pull_up          = pull_up;

        return obj;
    }

    onChange = (formData) => {
        var obj = this.getObjectData(formData);

        var deadlift         = obj.deadlift;
        var back_squat       = obj.back_squat
        var front_squat      = obj.front_squat
        var hex_bar_deadlift = obj.hex_bar_deadlift
        var bench_press      = obj.bench_press;
        var bent_over_row    = obj.bent_over_row;
        var clean            = obj.clean;
        var overhead_squat   = obj.overhead_squat;
        var snatch           = obj.snatch;
        var jerk             = obj.jerk;
        var pull_up          = obj.pull_up;

        this.setUserFormData(deadlift, back_squat, front_squat, hex_bar_deadlift, bench_press, bent_over_row, clean, overhead_squat, snatch, jerk, pull_up);
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/StrengthForm.js